import { iconCodes } from '@app/shared/cqes-icon/cqes-icon.component';
import { IStatusIcon } from '@app/shared/interfaces/common-interfaces';

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
}


export interface IBusinessUser {
  cmrId: string;
  companyId: string;
  customerUserId: string;
  email: string;
  emails: string[];
  fullNameBg: string;
  fullNameEn: string;
  groups: IBusinessGroup[];
  personalId: string;
  phoneNumber: string;
  phoneNumbers: string[];
  position: string;
  role: string;
  status: string;
}

export interface IUserInfoResponse {
  cmrId: string;
  code: string;
  emails: IEmail[];
  fullNameBg: string;
  fullNameEn: string;
  phones: IPhone[];
  responseCode: string;
  status: string;
}

export interface IGroupRequest {
  groupId?: string;
  companyCmrId: string,
  groupName: string,
  services: string[],
  employeeCustomerUserIds: string[];
}

export interface IEmail {
  id: string;
  status: string;
  email: string;
  type: string;
  certificate: boolean;
  correspondence: boolean;
  isPrimary: boolean;
  verified: boolean;
}

export interface IPhone {
  id: string;
  status: string;
  number: string;
  isPrimary: boolean;
  verified: boolean;
}

export interface IBusinessGroup {
  name: string;
  companyCustomerId: string;
  employeeCustomerUserIds: string[];
  id: string;
  serviceTypes: string[];
}

export interface IService {
  nameBg: string;
  nameEn: string;
  serviceType: string;
}

export interface ICompany {
  nameBg: string;
  nameEn: string;
  services: IService[];
  logo: string;
  cmrId: string;
  eik: string
}

export interface ISignRequestData {
  companyCmrId: string;
  companyNameBg: string;
  companyNameEn: string;
  senderCmrId: string;
  companyGroupId?: string[];
  senderNameBg: string;
  senderNameEn: string;
  ccCmrIdsAndEmails?: Record<number, string>;
  ccCmrId?: any;
}

export interface ISignRequestDataForRegisteredMail {
  companyCmrId: string;
  companyNameBg: string;
  companyNameEn: string;
  senderCmrId: string;
  companyGroupId?: string[];
  senderNameBg: string;
  senderNameEn: string;
}

export interface ISignRequestDataForRegisteredMail {
  companyCmrId: string;
  companyNameBg: string;
  companyNameEn: string;
  senderCmrId: string;
  companyGroupId?: string[];
  senderNameBg: string;
  senderNameEn: string;
}

export interface IParcelSignContext {
  name: string;
  description: string;
  recipientPays: boolean;
  toBeArchived: boolean;
  timestamp: number,
  validityTimestamp: number;
  isLogin: boolean;
  reminderPeriod?: number;
  notAvailableAfterSigning: boolean;
  parcelId?: string;
}

export interface IFileData {
  file?: File;
  index?: number;
  fileName: string;
  data: string;
  confirmText: string;
  hashAlgorithm: string;
  signatureType: string;
  contentFormat: string;
  toBeArchived: boolean;
  padesVisualSignature?: boolean;
  signaturePosition: any;
  contentType: string;
  signable: boolean;
  settings?: any;
  previewRequired: boolean;
}

export interface IParcelData {
  cmrId: string;
  sequenceIndex: number;
  settings?: any;
}

export interface IParcelSequenceData {
  cmrId: string;
  recipientNameBg: string;
  recipientNameEn: string;
  sequenceIndex: number;
  recipientPersonalId: string;
}

export interface IChangeStatusRequest {
  customerUserId: string;
  status: string;
}

export const serviceIconCodesDictionary = {
  'BATCH_SIGNING': iconCodes.developer_board,
  'WEB_IDENTIFICATION': iconCodes.web_identification_globus,
  'IDENTIFICATION': iconCodes.face,
  'ARCHIVE': iconCodes.menu,
  'REGISTERED_DELIVERY': iconCodes.mail_outline,
  'QES_REPORT': iconCodes.usb
};

export const rolesDictionary = {
  'MY_BTRUST_SUPER_ADMINISTRATOR': 'superAdministartor',
  'MY_BTRUST_ADMINISTRATOR': 'administartor',
  'MY_BTRUST_USER': 'user',
}

// export const allServices: IService[] = [
//   { nameBg: 'Изпращане на документи', nameEn: 'Send Documents', serviceType: 'SEND_DOCUMENTS_FOR_SIGN' },
//   { nameBg: 'Квалифицирана препоръчана поща', nameEn: 'Qualified Registered Mail', serviceType: 'QUALIFIED_REGISTERED_MAIL' },
//   { nameBg: 'Електронна идентификация', nameEn: 'E-identification', serviceType: 'IDENTIFICATION' },
//   { nameBg: 'Е-архив', nameEn: 'Е-archive', serviceType: 'ARCHIVE' },
//   { nameBg: 'Справки за хардуерни удостоверения', nameEn: 'Hardware Certificates Records', serviceType: 'HARDWARE_CERTIFICATES_RECORDS' },
//   { nameBg: 'Управление на хардуерни удостоверения', nameEn: 'Hardware Certificates Management', serviceType: 'HARDWARE_CERTIFICATES_MANAGEMENT' }
// ];

export enum DocumentStatus {
  ERROR = 'ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  SIGNED = 'SIGNED',
  SIGNING = 'SIGNING',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED',
  REVOKED = 'REVOKED',
  ARCHIVED = 'ARCHIVED',
  REMOVED = 'REMOVED',
  EXPIRED = 'EXPIRED',
  REQUESTED_FOR_SIGN = 'IN_PROGRESS',
  APPROVED_FROM_OWNER = 'IN_PROGRESS',
  SUCCESSFULLY_SIGNED = 'SIGNED',
  RECIEVED_FROM_RELYING_PARTY = 'RECEIVED',
  SIGNING_REJECTED_FROM_OWNER = 'REJECTED',
  WAITING_TO_BE_COMPOSED = 'IN_PROGRESS',
  DELETED = 'REMOVED',
  // Registered mail status
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  VIEWED = 'VIEWED',
  PENDING = 'PENDING',
  FAILED = 'FAILED'
}

export enum SortableClolumsNames {
  SERIAL_NUMBER = 'certSerialNumber',
  TEXT_TO_SHOW = 'displayedText',
  DATE = 'createdDate',
  RELYING_PARTY = 'relyingPartyName',
  SIGNED_DATE = 'signedDate',
  DOWNLOAD_TS = 'downloadeTimestamp'
}


export const DocumentStatusMap = new Map<string, IStatusIcon>();
DocumentStatusMap.set(DocumentStatus.ERROR, {
  icon: iconCodes.error,
  colorClass: 'text-danger',
  tooltip: 'historyTexts.documentStatusError',
  key: DocumentStatus.ERROR,
  text: 'error'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.IN_PROGRESS, {
  icon: iconCodes.info,
  colorClass: 'text-warning',
  tooltip: 'historyTexts.documentStatusSigning',
  key: DocumentStatus.IN_PROGRESS,
  text: 'in progress'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.SIGNED, {
  icon: iconCodes.done,
  colorClass: 'text-success',
  tooltip: 'historyTexts.documentStatusSigned',
  key: DocumentStatus.SIGNED,
  text: 'successfully signed'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.SIGNING, {
  icon: iconCodes.info,
  colorClass: 'text-warning',
  tooltip: 'historyTexts.documentStatusSigning',
  key: DocumentStatus.SIGNING,
  text: 'signing'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.RECEIVED, {
  icon: iconCodes.archive,
  colorClass: 'text-success',
  tooltip: 'historyTexts.documentStatusReceived',
  key: DocumentStatus.RECEIVED,
  text: 'received'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.REJECTED, {
  icon: iconCodes.blocked,
  colorClass: 'mat-primary',
  tooltip: 'historyTexts.documentStatusRejected',
  key: DocumentStatus.REJECTED,
  text: 'rejected by a recipient'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.REVOKED, {
  icon: iconCodes.blocked,
  colorClass: 'mat-primary',
  tooltip: 'historyTexts.documentStatusRevoked',
  key: DocumentStatus.REVOKED,
  text: 'rejected by owner'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.ARCHIVED, {
  icon: iconCodes.folder,
  colorClass: 'text-success',
  tooltip: 'historyTexts.documentStatusArchived',
  key: DocumentStatus.ARCHIVED,
  text: 'archived'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.REMOVED, {
  icon: iconCodes.delete,
  colorClass: 'text-danger',
  tooltip: 'historyTexts.documentStatusDeleted',
  key: DocumentStatus.REMOVED,
  text: 'removed'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.DELETED, {
  icon: iconCodes.delete,
  colorClass: 'text-danger',
  tooltip: 'historyTexts.documentStatusDeleted',
  key: DocumentStatus.DELETED,
  text: 'removed'
} as IStatusIcon);
DocumentStatusMap.set(DocumentStatus.EXPIRED, {
  icon: iconCodes.hourglass_empty,
  colorClass: 'mat-primary',
  tooltip: 'historyTexts.documentStatusExpired',
  key: DocumentStatus.EXPIRED,
  text: 'expired'
} as IStatusIcon);

DocumentStatusMap.set(DocumentStatus.SENT, {
  icon: iconCodes.done,
  colorClass: 'text-success',
  tooltip: 'historyTexts.documentStatusSentPackage',
  key: DocumentStatus.SIGNED,
  text: 'sent'
} as IStatusIcon);

DocumentStatusMap.set(DocumentStatus.DELIVERED, {
  icon: iconCodes.done_all,
  colorClass: 'text-success',
  tooltip: 'historyTexts.documentStatusDelivered',
  key: DocumentStatus.SIGNED,
  text: 'delivered'
} as IStatusIcon);

DocumentStatusMap.set(DocumentStatus.VIEWED, {
  icon: iconCodes.visibility,
  colorClass: 'text-success',
  tooltip: 'historyTexts.documentStatusViewed',
  key: DocumentStatus.SIGNED,
  text: 'viewed'
} as IStatusIcon);

DocumentStatusMap.set(DocumentStatus.PENDING, {
  icon: iconCodes.hourglass_empty,
  colorClass: 'mat-primary',
  tooltip: 'historyTexts.documentStatusRegisteredMailPending',
  key: DocumentStatus.PENDING,
  text: 'pending'
} as IStatusIcon);



export interface IFileDataOTC {
  file?: File;
  index?: number;
  contentAsBase64: string;
  fileName: string;
  legalFileName: string;
  padesVisualSignature: boolean;
  signaturePosition: any;
  toBeArchived: boolean;
  // confirmText?: string;
  // hashAlgorithm?: string;
  // signatureType?: string;
  // contentFormat?: string;
  contentType?: string;
  signable?: boolean;
  settings?: any;
}
DocumentStatusMap.set(DocumentStatus.FAILED, {
  icon: iconCodes.error,
  colorClass: 'text-danger',
  tooltip: 'historyTexts.documentStatusError',
  key: DocumentStatus.FAILED,
  text: 'failed'
} as IStatusIcon);

export enum ParcelType {
  BATCH_SIGNING = "BATCH_SIGNING",  // Пакетно подписване
  REGISTERED_DELIVERY = "REGISTERED_DELIVERY" // Препоръчана поща
}

export interface IParcelTypeDataForIcon {
  icon: string;
  tooltip: string;
}

export const DocumentTypeMap = new Map<string, IParcelTypeDataForIcon>();
DocumentTypeMap.set(ParcelType.BATCH_SIGNING, {
  icon: iconCodes.developer_board,
  tooltip: 'historyTexts.packageDocuments'
});

DocumentTypeMap.set(ParcelType.REGISTERED_DELIVERY, {
  icon: iconCodes.mail_outline,
  tooltip: 'historyTexts.registeredMail'
});
